import { apiResolver, useApi } from "@/api/useApi";
import { QuackChatConfigResponse } from "@/components/quack-chat/QuackChatConfig.model";
import { useConfigManager } from "./useConfigManager";
import { useMemo } from "react";

export type QuackchatConfigurationResponse = {
  token: string;
  quackchatConfiguration: QuackChatConfigResponse;
};

export function useQuackchatPlatformConfiguration(simulatorId?: string) {
  const { api } = useApi();
  const endpoint = useMemo(() => {
    return `/platform/quackchat-v2/configuration${
      simulatorId ? `?simulatorId=${simulatorId}` : ""
    }`;
  }, [simulatorId]);

  return useConfigManager<
    QuackChatConfigResponse,
    QuackChatConfigResponse,
    void
  >({
    name: simulatorId
      ? `quackchat-platform-configuration-${simulatorId}`
      : "quackchat-platform-configuration",

    getConfig: async () => {
      const res = await apiResolver<QuackchatConfigurationResponse>(
        api.get(endpoint)
      );

      return res.quackchatConfiguration;
    },
    updateConfig: async (request, signal) =>
      apiResolver<void>(
        api.put(
          endpoint,
          {
            configuration: request,
          },
          {
            signal,
          }
        )
      ),
  });
}
